import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="grid min-h-screen place-items-center px-4 text-center">
      <div>
        <p className="text-5xl font-bold">404</p>
        <p className="mt-2 text-neutral-400">Halaman tidak ditemukan.</p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-md bg-brand-500 px-4 py-2 text-sm text-white hover:bg-brand-600"
        >
          Kembali ke beranda
        </Link>
      </div>
    </div>
  );
}
